const ACCOUNTING_GROUP = 'Бухгалтерская отчетность'
const VAT_GROUP = 'НДС'
const BOOKS_GROUP = 'Книги покупок и продаж'
const SPECIAL_GROUP = 'Специальные отчеты'

export const REPORT_FAMILIES = Object.freeze({
  ALL: 'all',
  ACCOUNTING: 'accounting',
  VAT: 'vat',
  SPECIAL: 'special',
  ANALYTICS: 'analytics'
})

export const REPORT_FAMILY_META = Object.freeze({
  [REPORT_FAMILIES.ALL]: {
    title: 'Отчеты',
    description: 'Сформируйте регламентированный отчет или откройте сохраненный документ.'
  },
  [REPORT_FAMILIES.ACCOUNTING]: {
    title: 'Бухгалтерская отчетность',
    description: 'Баланс, финансовые результаты, капитал и движение денежных средств.'
  },
  [REPORT_FAMILIES.VAT]: {
    title: 'Отчеты по НДС',
    description: 'Декларация по НДС, книга покупок и книга продаж в одном разделе.'
  },
  [REPORT_FAMILIES.SPECIAL]: {
    title: 'Специальные отчеты',
    description: 'Отчеты специального назначения и будущие отраслевые формы.'
  }
})

export const REPORT_CODES = {
  BALANCE: 'balance_sheet',
  FIN_REZ: 'financial_results',
  CAP_CHANGE: 'capital_changes',
  MONEY_MOVE: 'cash_flow',
  MONEY_USING: 'targeted_funds',
  SUBCONTO: 'subconto_analysis',
  NDS: 'vat_declaration',
  SELLS_BOOK: 'sales_book',
  BUYS_BOOK: 'purchase_book'
}

export const LEGACY_REPORTS = Object.freeze({
  [REPORT_CODES.BALANCE]: Object.freeze({
    legacyType: 'balance',
    acceptedTypes: Object.freeze(['balance', REPORT_CODES.BALANCE]),
    infoRoute: 'reports_info_balance',
    editRoute: 'reports_edit_balance',
    routePath: 'balance'
  }),
  [REPORT_CODES.FIN_REZ]: Object.freeze({
    legacyType: 'fin_rez',
    acceptedTypes: Object.freeze(['fin_rez', REPORT_CODES.FIN_REZ]),
    infoRoute: 'reports_info_fin_rez',
    editRoute: 'reports_edit_fin_rez',
    routePath: 'fin/rez'
  }),
  [REPORT_CODES.CAP_CHANGE]: Object.freeze({
    legacyType: 'cap_change',
    acceptedTypes: Object.freeze(['cap_change', REPORT_CODES.CAP_CHANGE]),
    infoRoute: 'reports_info_cap_change',
    editRoute: 'reports_edit_cap_change',
    routePath: 'cap/change'
  }),
  [REPORT_CODES.MONEY_MOVE]: Object.freeze({
    legacyType: 'money_move',
    acceptedTypes: Object.freeze(['money_move', 'money_moving', REPORT_CODES.MONEY_MOVE]),
    infoRoute: 'reports_info_money_move',
    editRoute: 'reports_edit_money_move',
    routePath: 'money/move'
  }),
  [REPORT_CODES.MONEY_USING]: Object.freeze({
    legacyType: 'money_using',
    acceptedTypes: Object.freeze(['money_using', REPORT_CODES.MONEY_USING]),
    infoRoute: 'reports_info_money_using',
    editRoute: 'reports_edit_money_using',
    routePath: 'money/using'
  })
})

export const LEGACY_VALUE_LABELS = Object.freeze({
  current: 'Текущий период',
  previous: 'Предыдущий период',
  preprevious: 'Позапрошлый период',
  ust_cap: 'Уставный капитал',
  redeemed_papers: 'Собственные акции',
  add_cap: 'Добавочный капитал',
  rez_cap: 'Резервный капитал',
  dry_profit: 'Нераспределенная прибыль',
  total: 'Итого',
  previous_clear: 'Нераспределенная прибыль',
  previous_other: 'Другие статьи капитала'
})

export const LEGACY_VALUE_ORDER = Object.freeze([
  'current',
  'previous',
  'preprevious',
  'ust_cap',
  'redeemed_papers',
  'add_cap',
  'rez_cap',
  'dry_profit',
  'total',
  'previous_clear',
  'previous_other'
])

const DEFAULT_VALUE_COLUMNS = [
  { name: 'current', label: 'Текущий период' },
  { name: 'previous', label: 'Предыдущий период' }
]

const BALANCE_COLUMNS = [
  { name: 'current', label: 'На отчетную дату' },
  { name: 'previous', label: 'На конец прошлого года' },
  { name: 'preprevious', label: 'На конец позапрошлого года' }
]

export const ACCOUNTING_REPORT_ACTIONS = {
  [REPORT_CODES.BALANCE]: {
    action: 'generate_accounting_report',
    event: 'onGenerateAccountingReport'
  },
  [REPORT_CODES.FIN_REZ]: {
    action: 'generate_accounting_report',
    event: 'onGenerateAccountingReport'
  },
  [REPORT_CODES.CAP_CHANGE]: {
    action: 'generate_accounting_report',
    event: 'onGenerateAccountingReport'
  },
  [REPORT_CODES.MONEY_MOVE]: {
    action: 'generate_accounting_report',
    event: 'onGenerateAccountingReport'
  },
  [REPORT_CODES.MONEY_USING]: {
    action: 'generate_accounting_report',
    event: 'onGenerateAccountingReport'
  },
  [REPORT_CODES.SUBCONTO]: {
    action: 'generate_accounting_report',
    event: 'onGenerateAccountingReport'
  }
}

export const XML_EXPORT_ACTIONS = {
  [REPORT_CODES.NDS]: {
    label: 'Скачать XML',
    action: 'export_report',
    event: 'onExportReport'
  },
  [REPORT_CODES.SELLS_BOOK]: {
    label: 'Скачать XML',
    action: 'export_report',
    event: 'onExportReport'
  },
  [REPORT_CODES.BUYS_BOOK]: {
    label: 'Скачать XML',
    action: 'export_report',
    event: 'onExportReport'
  }
}

export const BOOK_DIRECTIONS = {
  [REPORT_CODES.SELLS_BOOK]: 'out',
  [REPORT_CODES.BUYS_BOOK]: 'in'
}

export const REPORTS = [
  {
    code: REPORT_CODES.BALANCE,
    name: 'Бухгалтерский баланс',
    group: ACCOUNTING_GROUP,
    family: REPORT_FAMILIES.ACCOUNTING,
    kind: 'accounting',
    routeName: 'reports_create_balance',
    description: 'Показывает активы, капитал и обязательства организации на отчетную дату.',
    valueColumns: BALANCE_COLUMNS,
    supportsMeasure: true,
    exportFormats: []
  },
  {
    code: REPORT_CODES.FIN_REZ,
    name: 'Отчет о финансовых результатах',
    group: ACCOUNTING_GROUP,
    family: REPORT_FAMILIES.ACCOUNTING,
    kind: 'accounting',
    routeName: 'reports_create_fin_rez',
    description: 'Показывает выручку, расходы, налог и чистую прибыль или убыток.',
    valueColumns: DEFAULT_VALUE_COLUMNS,
    supportsMeasure: true,
    exportFormats: []
  },
  {
    code: REPORT_CODES.CAP_CHANGE,
    name: 'Отчет об изменениях капитала',
    group: ACCOUNTING_GROUP,
    family: REPORT_FAMILIES.ACCOUNTING,
    kind: 'accounting',
    routeName: 'reports_create_cap_change',
    description: 'Отражает увеличение, уменьшение и корректировки капитала.',
    valueColumns: DEFAULT_VALUE_COLUMNS,
    supportsMeasure: true,
    exportFormats: []
  },
  {
    code: REPORT_CODES.MONEY_MOVE,
    name: 'Отчет о движении денежных средств',
    group: ACCOUNTING_GROUP,
    family: REPORT_FAMILIES.ACCOUNTING,
    kind: 'accounting',
    routeName: 'reports_create_money_move',
    description: 'Показывает денежные потоки по текущим, инвестиционным и финансовым операциям.',
    valueColumns: DEFAULT_VALUE_COLUMNS,
    supportsMeasure: true,
    exportFormats: []
  },
  {
    code: REPORT_CODES.MONEY_USING,
    name: 'Отчет о целевом использовании средств',
    group: SPECIAL_GROUP,
    family: REPORT_FAMILIES.SPECIAL,
    kind: 'accounting',
    routeName: 'reports_create_money_using',
    description: 'Показывает поступление, использование и остаток целевых средств.',
    valueColumns: DEFAULT_VALUE_COLUMNS,
    supportsMeasure: true,
    exportFormats: []
  },
  {
    code: REPORT_CODES.SUBCONTO,
    name: 'Анализ субконто',
    group: 'Аналитика',
    family: REPORT_FAMILIES.ANALYTICS,
    kind: 'subconto',
    routeName: 'reports_create_subconto_analysis',
    description: 'Показывает сальдо и обороты по выбранной аналитике сразу по всем счетам.',
    supportsMeasure: true,
    exportFormats: ['csv', 'print'],
    catalog: false
  },
  {
    code: REPORT_CODES.NDS,
    name: 'Отчет по НДС / декларация по НДС',
    group: VAT_GROUP,
    family: REPORT_FAMILIES.VAT,
    kind: 'vat',
    routeName: 'reports_create_nds',
    description: 'Сводит НДС к уплате или вычету и готовит XML декларации.',
    supportsMeasure: false,
    exportFormats: ['xml']
  },
  {
    code: REPORT_CODES.SELLS_BOOK,
    name: 'Книга продаж',
    group: BOOKS_GROUP,
    family: REPORT_FAMILIES.VAT,
    kind: 'book',
    routeName: 'reports_create_sells_book',
    description: 'Показывает исходящие документы, включенные в книгу продаж за период НДС.',
    direction: 'out',
    supportsMeasure: false,
    exportFormats: ['xml']
  },
  {
    code: REPORT_CODES.BUYS_BOOK,
    name: 'Книга покупок',
    group: BOOKS_GROUP,
    family: REPORT_FAMILIES.VAT,
    kind: 'book',
    routeName: 'reports_create_buys_book',
    description: 'Показывает входящие документы, включенные в книгу покупок за период НДС.',
    direction: 'in',
    supportsMeasure: false,
    exportFormats: ['xml']
  }
]

export const REPORT_GROUPS = [
  ACCOUNTING_GROUP,
  VAT_GROUP,
  BOOKS_GROUP,
  SPECIAL_GROUP
]

const row = (key, name, code, section, options = {}) => ({
  key,
  name,
  code,
  section,
  isTotal: Boolean(options.isTotal)
})

export const ACCOUNTING_REPORT_ROWS = {
  [REPORT_CODES.BALANCE]: [
    row('nematerial_i', 'Нематериальные активы', '1110', 'I. Внеоборотные активы'),
    row('dev_result_i', 'Результаты исследований и разработок', '1120', 'I. Внеоборотные активы'),
    row('nonmat_assets_i', 'Нематериальные поисковые активы', '1130', 'I. Внеоборотные активы'),
    row('mat_act_i', 'Материальные поисковые активы', '1140', 'I. Внеоборотные активы'),
    row('fix_assets_i', 'Основные средства', '1150', 'I. Внеоборотные активы'),
    row('mat_assets_i', 'Доходные вложения в материальные ценности', '1160', 'I. Внеоборотные активы'),
    row('fin_income_i', 'Финансовые вложения', '1170', 'I. Внеоборотные активы'),
    row('tax_active_i', 'Отложенные налоговые активы', '1180', 'I. Внеоборотные активы'),
    row('other_assets_i', 'Прочие внеоборотные активы', '1190', 'I. Внеоборотные активы'),
    row('total_i', 'Итого по разделу I', '1100', 'I. Внеоборотные активы', { isTotal: true }),
    row('stocks_ii', 'Запасы', '1210', 'II. Оборотные активы'),
    row('tax_nds_ii', 'НДС по приобретенным ценностям', '1220', 'II. Оборотные активы'),
    row('deb_dolg_ii', 'Дебиторская задолженность', '1230', 'II. Оборотные активы'),
    row('fin_income_ii', 'Финансовые вложения', '1240', 'II. Оборотные активы'),
    row('money_ii', 'Денежные средства и денежные эквиваленты', '1250', 'II. Оборотные активы'),
    row('other_assets_ii', 'Прочие оборотные активы', '1260', 'II. Оборотные активы'),
    row('total_ii', 'Итого по разделу II', '1200', 'II. Оборотные активы', { isTotal: true }),
    row('active_balance', 'Баланс', '1600', 'Актив', { isTotal: true }),
    row('auth_cap_iii', 'Уставный капитал', '1310', 'III. Капитал и резервы'),
    row('self_prom_iii', 'Собственные акции, выкупленные у акционеров', '1320', 'III. Капитал и резервы'),
    row('reval_assets_iii', 'Переоценка внеоборотных активов', '1340', 'III. Капитал и резервы'),
    row('add_cap_iii', 'Добавочный капитал', '1350', 'III. Капитал и резервы'),
    row('rezerv_kap_iii', 'Резервный капитал', '1360', 'III. Капитал и резервы'),
    row('ret_earn_iii', 'Нераспределенная прибыль', '1370', 'III. Капитал и резервы'),
    row('total_iii', 'Итого по разделу III', '1300', 'III. Капитал и резервы', { isTotal: true }),
    row('cred_money_iv', 'Заемные средства', '1410', 'IV. Долгосрочные обязательства'),
    row('delayed_tax_iv', 'Отложенные налоговые обязательства', '1420', 'IV. Долгосрочные обязательства'),
    row('est_liab_iv', 'Оценочные обязательства', '1430', 'IV. Долгосрочные обязательства'),
    row('other_oblig_iv', 'Прочие обязательства', '1450', 'IV. Долгосрочные обязательства'),
    row('total_iv', 'Итого по разделу IV', '1400', 'IV. Долгосрочные обязательства', { isTotal: true }),
    row('dolg_v', 'Заемные средства', '1510', 'V. Краткосрочные обязательства'),
    row('cred_bill_v', 'Кредиторская задолженность', '1520', 'V. Краткосрочные обязательства'),
    row('fut_income_v', 'Доходы будущих периодов', '1530', 'V. Краткосрочные обязательства'),
    row('est_liab_v', 'Оценочные обязательства', '1540', 'V. Краткосрочные обязательства'),
    row('other_oblig_v', 'Прочие обязательства', '1550', 'V. Краткосрочные обязательства'),
    row('total_v', 'Итого по разделу V', '1500', 'V. Краткосрочные обязательства', { isTotal: true }),
    row('passive_balance', 'Баланс', '1700', 'Пассив', { isTotal: true })
  ],
  [REPORT_CODES.FIN_REZ]: [
    row('profit', 'Выручка', '2110', 'Финансовые результаты'),
    row('sebest', 'Себестоимость продаж', '2120', 'Финансовые результаты'),
    row('val_profit', 'Валовая прибыль / убыток', '2100', 'Финансовые результаты', { isTotal: true }),
    row('comm_costs', 'Коммерческие расходы', '2210', 'Финансовые результаты'),
    row('man_costs', 'Управленческие расходы', '2220', 'Финансовые результаты'),
    row('sell_profit', 'Прибыль / убыток от продаж', '2200', 'Финансовые результаты', { isTotal: true }),
    row('another_org_prof', 'Доходы от участия в других организациях', '2310', 'Прочие доходы и расходы'),
    row('take_percent', 'Проценты к получению', '2320', 'Прочие доходы и расходы'),
    row('make_perc', 'Проценты к уплате', '2330', 'Прочие доходы и расходы'),
    row('another_profit', 'Прочие доходы', '2340', 'Прочие доходы и расходы'),
    row('another_costs', 'Прочие расходы', '2350', 'Прочие доходы и расходы'),
    row('profit_gross', 'Прибыль / убыток до налогообложения', '2300', 'Итоги', { isTotal: true }),
    row('profit_tax', 'Налог на прибыль', '2410', 'Итоги'),
    row('current_tax_profit', 'Текущий налог на прибыль', '2411', 'Итоги'),
    row('delayed_tax_profit', 'Отложенный налог на прибыль', '2421', 'Итоги'),
    row('another', 'Прочее', '2460', 'Итоги'),
    row('clear_profit', 'Чистая прибыль / убыток', '2400', 'Итоги', { isTotal: true }),
    row('activ_rez', 'Результат от переоценки внеоборотных активов', '2510', 'Справочно'),
    row('rez_another_operations', 'Результат от прочих операций', '2520', 'Справочно'),
    row('tax_operations', 'Налог на прибыль от операций', '2530', 'Справочно'),
    row('total_fin_rez', 'Совокупный финансовый результат', '2500', 'Справочно', { isTotal: true }),
    row('basic_profit_oblig', 'Базовая прибыль / убыток на акцию', '2900', 'Справочно'),
    row('profit_oblig', 'Разводненная прибыль / убыток на акцию', '2910', 'Справочно')
  ],
  [REPORT_CODES.MONEY_MOVE]: [
    row('total_income', 'Поступления всего', '4110', 'Текущие операции', { isTotal: true }),
    row('sell_goods', 'От продажи продукции, товаров, работ и услуг', '4111', 'Текущие операции'),
    row('rent_com_payments', 'Арендные, лицензионные и комиссионные платежи', '4112', 'Текущие операции'),
    row('resell_fin', 'От перепродажи финансовых вложений', '4113', 'Текущие операции'),
    row('other_income', 'Прочие поступления', '4119', 'Текущие операции'),
    row('payments_total', 'Платежи всего', '4120', 'Текущие операции', { isTotal: true }),
    row('payments_sender', 'Поставщикам за сырье, материалы, работы, услуги', '4121', 'Текущие операции'),
    row('payments_salary', 'В связи с оплатой труда работников', '4122', 'Текущие операции'),
    row('debt_perc', 'Проценты по долговым обязательствам', '4123', 'Текущие операции'),
    row('income_tax', 'Налог на прибыль организаций', '4124', 'Текущие операции'),
    row('payement_other_paymetns', 'Прочие платежи', '4129', 'Текущие операции'),
    row('payment_current_saldo', 'Сальдо денежных потоков от текущих операций', '4100', 'Текущие операции', { isTotal: true }),
    row('invest_income_total', 'Поступления всего', '4210', 'Инвестиционные операции', { isTotal: true }),
    row('sell_outbound_fin', 'От продажи внеоборотных активов', '4211', 'Инвестиционные операции'),
    row('inv_sell_papers_others', 'От продажи акций и долей', '4212', 'Инвестиционные операции'),
    row('inv_sell_debts', 'От возврата предоставленных займов', '4213', 'Инвестиционные операции'),
    row('inv_divid', 'Дивиденды и проценты по финансовым вложениям', '4214', 'Инвестиционные операции'),
    row('inv_other_income', 'Прочие поступления', '4219', 'Инвестиционные операции'),
    row('inv_total_payments', 'Платежи всего', '4220', 'Инвестиционные операции', { isTotal: true }),
    row('inv_rec_outbound_fin', 'На приобретение внеоборотных активов', '4221', 'Инвестиционные операции'),
    row('inv_rec_papers', 'На приобретение акций и долей', '4222', 'Инвестиционные операции'),
    row('inv_rec_debts', 'На приобретение долговых ценных бумаг', '4223', 'Инвестиционные операции'),
    row('inv_rec_debts_perc', 'Проценты по долговым обязательствам', '4224', 'Инвестиционные операции'),
    row('inv_other_payments', 'Прочие платежи', '4229', 'Инвестиционные операции'),
    row('inv_saldo', 'Сальдо денежных потоков от инвестиционных операций', '4200', 'Инвестиционные операции', { isTotal: true }),
    row('fin_income_total', 'Поступления всего', '4310', 'Финансовые операции', { isTotal: true }),
    row('fin_cred', 'Получение кредитов и займов', '4311', 'Финансовые операции'),
    row('fin_invest', 'Денежные вклады собственников', '4312', 'Финансовые операции'),
    row('fin_create_papers', 'От выпуска акций', '4313', 'Финансовые операции'),
    row('fin_create_oblig', 'От выпуска облигаций', '4314', 'Финансовые операции'),
    row('fin_other_income', 'Прочие поступления', '4319', 'Финансовые операции'),
    row('fin_payments_total', 'Платежи всего', '4320', 'Финансовые операции', { isTotal: true }),
    row('fin_pay_exit_paper', 'Собственникам в связи с выкупом акций', '4321', 'Финансовые операции'),
    row('fin_pay_div', 'На уплату дивидендов', '4322', 'Финансовые операции'),
    row('fin_pay_oblig', 'В связи с погашением кредитов и займов', '4323', 'Финансовые операции'),
    row('fin_pay_other_payments', 'Прочие платежи', '4329', 'Финансовые операции'),
    row('fin_saldo_fin_oper', 'Сальдо денежных потоков от финансовых операций', '4300', 'Финансовые операции', { isTotal: true }),
    row('fin_saldo_period', 'Сальдо денежных потоков за отчетный период', '4400', 'Итоги', { isTotal: true }),
    row('fin_money_remainder_start', 'Остаток денежных средств на начало периода', '4450', 'Итоги'),
    row('fin_money_remainder_end', 'Остаток денежных средств на конец периода', '4500', 'Итоги', { isTotal: true }),
    row('fin_money_rub_to_usd', 'Влияние изменения курса иностранной валюты', '4490', 'Итоги')
  ],
  [REPORT_CODES.MONEY_USING]: [
    row('mon_ost', 'Остаток средств на начало отчетного года', '6100', 'Остаток'),
    row('mon_inc_invite', 'Вступительные взносы', '6210', 'Поступления'),
    row('chlen_income', 'Членские взносы', '6215', 'Поступления'),
    row('cel_income', 'Целевые взносы', '6220', 'Поступления'),
    row('vol_mat_income', 'Добровольные имущественные взносы и пожертвования', '6230', 'Поступления'),
    row('income_actions', 'Прибыль от приносящей доход деятельности', '6240', 'Поступления'),
    row('another_income', 'Прочие поступления', '6250', 'Поступления'),
    row('total_income', 'Поступило средств всего', '6200', 'Поступления', { isTotal: true }),
    row('outcome_cel', 'Расходы на целевые мероприятия', '6310', 'Использование'),
    row('soc_help', 'Социальная и благотворительная помощь', '6311', 'Использование'),
    row('conf_outcome', 'Проведение конференций, совещаний и мероприятий', '6312', 'Использование'),
    row('another_conf', 'Иные мероприятия', '6313', 'Использование'),
    row('managers_sal', 'Расходы на содержание аппарата управления', '6320', 'Использование'),
    row('salary', 'Расходы, связанные с оплатой труда', '6321', 'Использование'),
    row('non_salary', 'Выплаты, не связанные с оплатой труда', '6322', 'Использование'),
    row('com_drive', 'Расходы на служебные командировки', '6323', 'Использование'),
    row('household', 'Содержание помещений, зданий, транспорта', '6324', 'Использование'),
    row('repair', 'Ремонт основных средств и иного имущества', '6325', 'Использование'),
    row('anouther_outcome', 'Прочие расходы', '6326', 'Использование'),
    row('inventary', 'Приобретение основных средств и инвентаря', '6330', 'Использование'),
    row('another', 'Прочее использование', '6350', 'Использование'),
    row('total_used', 'Использовано средств всего', '6300', 'Использование', { isTotal: true }),
    row('remainder', 'Остаток средств на конец отчетного года', '6400', 'Остаток', { isTotal: true })
  ],
  [REPORT_CODES.CAP_CHANGE]: [
    row('i_cap_val', 'Величина капитала на начало периода', '', 'I. Движение капитала'),
    row('i_cap_increase', 'Увеличение капитала всего', '', 'I. Движение капитала', { isTotal: true }),
    row('i_clear_profit', 'Чистая прибыль', '', 'I. Движение капитала'),
    row('i_reval_goods', 'Переоценка имущества', '', 'I. Движение капитала'),
    row('i_income_cap_increase', 'Доходы, относящиеся непосредственно на увеличение капитала', '', 'I. Движение капитала'),
    row('i_add_papres_create', 'Дополнительный выпуск акций', '', 'I. Движение капитала'),
    row('i_papres_val_increase', 'Увеличение номинальной стоимости акций', '', 'I. Движение капитала'),
    row('i_nom_papers_price_reval', 'Реорганизация юридического лица', '', 'I. Движение капитала'),
    row('i_cap_decrease', 'Уменьшение капитала всего', '', 'I. Движение капитала', { isTotal: true }),
    row('i_cap_decr_loss', 'Убыток', '', 'I. Движение капитала'),
    row('i_cap_decr_reval', 'Переоценка имущества', '', 'I. Движение капитала'),
    row('i_cap_decr_cost', 'Расходы, относящиеся непосредственно на уменьшение капитала', '', 'I. Движение капитала'),
    row('i_cap_decr_papers_price_decr', 'Уменьшение номинальной стоимости акций', '', 'I. Движение капитала'),
    row('i_cap_decr_papres_count', 'Уменьшение количества акций', '', 'I. Движение капитала'),
    row('i_cap_decr_reorg', 'Реорганизация юридического лица', '', 'I. Движение капитала'),
    row('i_cap_decr_divid', 'Дивиденды', '', 'I. Движение капитала'),
    row('i_cap_decr_add_cap_decr', 'Дополнительное уменьшение капитала', '', 'I. Движение капитала'),
    row('i_rez_cap_change', 'Изменение добавочного капитала', '', 'I. Движение капитала'),
    row('i_rez_cap_value', 'Величина капитала на конец периода', '', 'I. Движение капитала', { isTotal: true }),
    row('i_total_cap_incr', 'Увеличение капитала всего за предыдущий период', '', 'I. Движение капитала', { isTotal: true }),
    row('i_rez_cap_clear_profit', 'Чистая прибыль за предыдущий период', '', 'I. Движение капитала'),
    row('i_tax_operations', 'Переоценка имущества за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_income_cap_incr', 'Доходы, отнесенные на увеличение капитала за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_add_papers_create', 'Дополнительный выпуск акций за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_add_nom_price_papers', 'Увеличение номинальной стоимости акций за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_reorg', 'Реорганизация юридического лица за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_total_cap_decr', 'Уменьшение капитала всего за предыдущий период', '', 'I. Движение капитала', { isTotal: true }),
    row('i_rez_cap_loss', 'Убыток за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_reval', 'Переоценка имущества при уменьшении капитала за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_cap_decr', 'Расходы, отнесенные на уменьшение капитала за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_decr_price_papers', 'Уменьшение номинальной стоимости акций за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_papers_decr', 'Уменьшение количества акций за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_decr_reorg', 'Реорганизация юридического лица при уменьшении капитала', '', 'I. Движение капитала'),
    row('i_rez_cap_decr_divid', 'Дивиденды за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_decr_cap_change', 'Изменение добавочного капитала за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_decr_change', 'Изменение резервного капитала за предыдущий период', '', 'I. Движение капитала'),
    row('i_rez_cap_decr_value', 'Величина капитала на конец предыдущего периода', '', 'I. Движение капитала', { isTotal: true }),
    row('ii_cap_total_before_corr', 'Капитал до корректировок', '', 'II. Корректировки'),
    row('ii_cap_total_corr_polit', 'Корректировка в связи с изменением учетной политики', '', 'II. Корректировки'),
    row('ii_cap_total_debug', 'Корректировка в связи с исправлением ошибок', '', 'II. Корректировки'),
    row('ii_cap_total_after_corr', 'Капитал после корректировок', '', 'II. Корректировки', { isTotal: true }),
    row('ii_income_undef_profit', 'Нераспределенная прибыль до корректировок', '', 'II. Корректировки'),
    row('ii_income_corr_polit', 'Корректировка нераспределенной прибыли', '', 'II. Корректировки'),
    row('ii_income_debug', 'Исправление ошибок по нераспределенной прибыли', '', 'II. Корректировки'),
    row('ii_income_after_corr', 'Нераспределенная прибыль после корректировок', '', 'II. Корректировки', { isTotal: true }),
    row('ii_other_before_corr', 'Другие статьи капитала до корректировок', '', 'II. Корректировки'),
    row('ii_other_corr_polit', 'Корректировка других статей капитала', '', 'II. Корректировки'),
    row('ii_other_debug', 'Исправление ошибок по другим статьям капитала', '', 'II. Корректировки'),
    row('ii_other_after_corr', 'Другие статьи капитала после корректировок', '', 'II. Корректировки', { isTotal: true }),
    row('iii_clear_act', 'Чистые активы', '', 'III. Чистые активы', { isTotal: true })
  ]
}

export const BOOK_COLUMNS = {
  [REPORT_CODES.SELLS_BOOK]: [
    { name: 'line_no', label: 'N', field: 'line_no', align: 'left' },
    { name: 'date', label: 'Дата регистрации', field: 'invoice_date', align: 'left', sortable: true },
    { name: 'invoice', label: 'Счет-фактура', field: 'invoice_number', align: 'left' },
    { name: 'correction', label: 'Исправление', field: 'correction_number', align: 'left' },
    { name: 'operation_code', label: 'Код операции', field: 'operation_code', align: 'left' },
    { name: 'counterparty', label: 'Покупатель', field: 'counterparty_name', align: 'left' },
    { name: 'inn_kpp', label: 'ИНН / КПП покупателя', field: 'inn_kpp', align: 'left' },
    { name: 'amount', label: 'Стоимость продаж', field: 'amount', align: 'right' },
    { name: 'vat_rate', label: 'Ставка НДС', field: 'vat_rate', align: 'left' },
    { name: 'vat_amount', label: 'Сумма НДС', field: 'vat_amount', align: 'right' },
    { name: 'currency', label: 'Валюта', field: 'currency', align: 'left' },
    { name: 'source', label: 'Источник', field: 'source', align: 'left' }
  ],
  [REPORT_CODES.BUYS_BOOK]: [
    { name: 'line_no', label: 'N', field: 'line_no', align: 'left' },
    { name: 'date', label: 'Дата регистрации', field: 'invoice_date', align: 'left', sortable: true },
    { name: 'invoice', label: 'Счет-фактура продавца', field: 'invoice_number', align: 'left' },
    { name: 'correction', label: 'Исправление', field: 'correction_number', align: 'left' },
    { name: 'operation_code', label: 'Код операции', field: 'operation_code', align: 'left' },
    { name: 'counterparty', label: 'Продавец', field: 'counterparty_name', align: 'left' },
    { name: 'inn_kpp', label: 'ИНН / КПП продавца', field: 'inn_kpp', align: 'left' },
    { name: 'amount', label: 'Стоимость покупки', field: 'amount', align: 'right' },
    { name: 'vat_rate', label: 'Ставка НДС', field: 'vat_rate', align: 'left' },
    { name: 'vat_amount', label: 'НДС к вычету', field: 'vat_amount', align: 'right' },
    { name: 'currency', label: 'Валюта', field: 'currency', align: 'left' },
    { name: 'source', label: 'Источник', field: 'source', align: 'left' }
  ]
}

export function getReportByCode(code) {
  return REPORTS.find((item) => item.code === code)
}

export function getReportsByGroup(family = REPORT_FAMILIES.ALL) {
  const available = REPORTS.filter((report) => {
    if (report.catalog === false) {
      return false
    }
    return family === REPORT_FAMILIES.ALL || report.family === family
  })
  return REPORT_GROUPS.map((group) => ({
    group,
    reports: available.filter((report) => report.group === group)
  })).filter((item) => item.reports.length > 0)
}

export function getReportsByFamily(family = REPORT_FAMILIES.ALL) {
  return getReportsByGroup(family).flatMap((item) => item.reports)
}

export function reportSupportsXmlExport(code) {
  return XML_EXPORT_ACTIONS[code] !== undefined
}

export function getLegacyReportDefinition(codeOrType) {
  if (LEGACY_REPORTS[codeOrType]) {
    return { reportCode: codeOrType, ...LEGACY_REPORTS[codeOrType] }
  }
  const entry = Object.entries(LEGACY_REPORTS).find(([, definition]) => {
    return definition.acceptedTypes.includes(codeOrType)
  })
  return entry ? { reportCode: entry[0], ...entry[1] } : null
}
